<template>
  <div v-if="$store.state.show.chat" class="chat-box">
    <div class="text-center" v-if="$store.state.show.conversation_load">
      <v-overlay
        color="rgba(238,238,238,0.93)"
        style="position: absolute; min-height: 100%; top: -19px"
        opacity=".8"
      >
        <v-progress-circular
          :size="70"
          :width="7"
          color="#1141ce"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </div>
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        top
        :small="$store.state.isMobile ? true : false"
        class="ma-2"
        color="#1141ce"
        @click="out()"
      >
        <v-icon> mdi-chevron-double-left</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        :small="$store.state.isMobile ? true : false"
        class="ma-2"
        color="#1141ce"
        @click="$vuetify.goTo(0)"
      >
        <v-icon> mdi-chevron-double-up</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-btn
      v-show="$store.state.show.UserWritingDots"
      dark
      fixed
      top
      style="right: 45%; z-index: 99999"
      :small="$store.state.isMobile ? true : false"
      color="#1141ce"
      class="mt-3"
    >
      <div id="wave">
        <Dots />
      </div>
    </v-btn>
    <div class="chat-box-body">
      <div class="chat-content" ref="container">
        <div
          class="chat-message-container"
          v-for="(msg, index) in user_messages"
          :key="index"
          :class="[
            msg.context === 'whatsapp_mode' ? 'whatsapp' : '',
            chat_sender(msg.sender_type).class,
          ]"
          v-show="msg.context === context.mode || context.mode == 'all'"
        >
          <v-icon
            :class="
              msg.sender_type === 'self'
                ? 'chat-avatar-left'
                : 'chat-avatar-right'
            "
            >{{ chat_sender(msg.sender_type).icon }}</v-icon
          >
          <div class="chat-message">
            <!-- send by automated email btn -->
            <v-btn
              absolute
              top
              right
              class="email_btn"
              :class="msg.sender_type === 'self' ? 'email_btn_left' : ''"
              small
              fab
              elevation="1"
              v-if="
                $store.state.messages.Send_by_email_select !== undefined &&
                !disable_options(msg)
              "
              @click="select_elements_email(msg)"
            >
              <v-icon
                color="#EE6C4D"
                v-if="selected_email_msgs.includes(msg.id_msg)"
              >
                mdi-circle-slice-8</v-icon
              >
              <v-icon color="#EE6C4D" v-else> mdi-circle-outline </v-icon>
            </v-btn>
            <MsgOptions v-else :msg="msg" :index="index" />
            <Mlook
              v-if="msg.content && msg.content.look"
              :message="msg.content"
            />
            <Grid
              v-else-if="msg.content && msg.content.grid"
              :message="msg.content"
            />
            <Carsul
              v-else-if="msg.content && msg.content.carousel"
              :message="msg.content"
            />
            <Attachment
              v-else-if="msg.content && msg.content.attachment"
              :message="msg.content"
            />
            <Brands
              v-else-if="msg.content && msg.content.brands"
              :message="msg.content"
            />
            <Buttons
              v-else-if="msg.content && msg.content.buttons"
              :message="msg"
            />
            <AgnetAssign
              v-else-if="msg.content && msg.content.type == 'agent_assign'"
              :message="msg"
            />
            <Chat v-else :message="msg" />
            <v-row no-gutters dense v-if="messengerConfig.showTime">
              <v-col cols="12" class="text-end message-time">
                <v-list-item class="ma-0 pa-0 mt-1">
                  <v-list-item-content class="ma-0 pa-0">
                    <v-list-item-subtitle
                      class="ma-0 pa-0 caption"
                      style="font-size: 11px !important"
                    >
                      <v-row no-gutters justify="end" align="center">
                        <!-- <v-col cols="auto" class="mr-2" v-show="msg.ts_slack">
                          <v-tooltip bottom color="#3F0E40">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-on="on"
                                v-bind="attrs"
                                small
                                dark
                                color="#3F0E40"
                                >mdi-slack</v-icon
                              >
                            </template>
                            <span class="caption"><b>Sent from slack</b></span>
                          </v-tooltip>
                        </v-col> -->
                        <v-col cols="auto" class="mt-1">
                          {{ time_format(msg) }}
                        </v-col>
                        <v-col
                          cols="auto"
                          class="ml-2"
                          v-show="msg.context === 'whatsapp_mode'"
                        >
                          <v-tooltip bottom color="green darken-4">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-on="on"
                                v-bind="attrs"
                                small
                                dark
                                color="green darken-4"
                                >mdi-whatsapp</v-icon
                              >
                            </template>
                            <span class="caption"
                              ><b>Sent from WhatsApp</b></span
                            >
                          </v-tooltip>
                        </v-col>
                        <v-col
                          cols="auto"
                          class="ml-2"
                          v-show="msg.context === 'video_call'"
                        >
                          <v-tooltip bottom color="#3F0E40">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-on="on"
                                v-bind="attrs"
                                small
                                dark
                                color="#3F0E40"
                                >mdi-video-box</v-icon
                              >
                            </template>
                            <span class="caption">
                              <b>Sent during a Video Call</b>
                            </span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <!-- detect email  btn -->
            <v-tooltip
              v-if="$store.state.messages.Send_by_email_select === undefined"
              top
              color="#1141ce"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  class="EmailFound"
                  v-if="DetectEmail(msg).match"
                  @click="SetEmail(DetectEmail(msg).found)"
                  color="#1F271B"
                >
                  <v-badge dot overlap bottom bordered left color="pink">
                    <v-icon size="22"> mdi-email-search </v-icon>
                  </v-badge>
                </v-btn>
              </template>
              <span>{{ $t("messanger.chat.detect_emails") }}</span>
            </v-tooltip>
          </div>
        </div>
      </div>
      <v-container class="pb-12" fluid>
        <v-row dense no-gutters justify="center" align="center">
          <v-col cols="12" md="11" sm="11" lg="8">
            <form @keydown.enter.exact.prevent @keyup.enter.exact="submit()">
              <VueEditor
                ref="editor"
                v-model="chat_input"
                :editorOptions="editorOptions"
                class="pb-0 editor"
                :class="xl_resize ? 'mb-2' : ''"
                :placeholder="$t('messanger.chat.send_placeholder')"
                @focus="chat_focus"
                @blur="chat_blur"
                :disabled="generateAiQestion"
              />
            </form>
          </v-col>
          <v-col class="mt-2" cols="auto" md="auto" sm="auto" lg="auto">
            <v-tooltip color="black" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  v-on="on"
                  :small="xl_resize && $store.state.isMobile"
                  :x-large="!xl_resize && !$store.state.isMobile"
                  :large="xl_resize && !$store.state.isMobile"
                  dark
                  @click="submit()"
                  class="mx-1 ml-4"
                >
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("messanger.chat.send_text") }} </span>
            </v-tooltip>
            <!--  mon code-->
            <v-tooltip color="black" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  v-on="on"
                  :small="xl_resize && $store.state.isMobile"
                  :x-large="!xl_resize && !$store.state.isMobile"
                  :large="xl_resize && !$store.state.isMobile"
                  dark
                  @click="generate_next_response()"
                  :loading="generateAiQestion"
                  class="mx-1 ml-4"
                >
                  <v-icon>mdi-creation</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("messanger.chat.generate_ai_question") }} </span>
            </v-tooltip>
            <v-tooltip color="black" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  v-on="on"
                  :small="xl_resize && $store.state.isMobile"
                  :x-large="!xl_resize && !$store.state.isMobile"
                  :large="xl_resize && !$store.state.isMobile"
                  :dark="$store.state.chat_user.phone_number ? true : false"
                  @click="submit(true)"
                  class="mx-1"
                  :disabled="
                    !$store.state.chat_user.phone_number ? true : false
                  "
                >
                  <v-icon>mdi-whatsapp</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("messanger.chat.send_whatsapp") }} </span>
            </v-tooltip>
            <v-tooltip color="black" top>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  class="mx-1"
                  :loading="isSelecting"
                  v-on="tooltip"
                  @click="onButtonClick"
                  dark
                  fab
                  :small="xl_resize && $store.state.isMobile"
                  :x-large="!xl_resize && !$store.state.isMobile"
                  :large="xl_resize && !$store.state.isMobile"
                >
                  <v-icon style="transform: rotate(90deg)"
                    >mdi-attachment</v-icon
                  >
                </v-btn>
              </template>
              <span>{{ $t("messanger.chat.send_attachment") }}</span>
            </v-tooltip>
            <v-tooltip color="black" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  v-on="on"
                  class="mx-1"
                  dark
                  @click="looks()"
                  :small="xl_resize && $store.state.isMobile"
                  :x-large="!xl_resize && !$store.state.isMobile"
                  :large="xl_resize && !$store.state.isMobile"
                >
                  <v-icon>mdi-tshirt-crew</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("messanger.chat.send_look") }} </span>
            </v-tooltip>
            <v-tooltip color="black" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  v-on="on"
                  class="mx-1"
                  :dark="!disableRating"
                  @click="compute_rating()"
                  :small="xl_resize && $store.state.isMobile"
                  :x-large="!xl_resize && !$store.state.isMobile"
                  :large="xl_resize && !$store.state.isMobile"
                  :disabled="disableRating"
                >
                  <v-icon>mdi-star</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("messanger.chat.send_rating") }} </span>
            </v-tooltip>
            <v-menu top offset-y rounded>
              <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip dark top color="black">
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                      fab
                      v-bind="attrs"
                      v-on="{ ...tooltip, ...menu }"
                      class="mx-1"
                      :small="xl_resize && $store.state.isMobile"
                      :x-large="!xl_resize && !$store.state.isMobile"
                      :large="xl_resize && !$store.state.isMobile"
                      :loading="email_send_loader"
                      :disabled="
                        !$store.state.messages.Send_by_email_select_elements
                          .length
                      "
                      :dark="
                        $store.state.messages.Send_by_email_select_elements
                          .length
                          ? true
                          : false
                      "
                    >
                      <v-icon
                        v-if="
                          $store.state.messages.Send_by_email_select_elements
                            .length
                        "
                        >mdi-email-arrow-right</v-icon
                      >
                      <v-icon v-else>mdi-email-off</v-icon>
                      <v-badge
                        v-if="
                          $store.state.messages.Send_by_email_select_elements
                            .length
                        "
                        bordered
                        color="#D64933"
                        :content="
                          $store.state.messages.Send_by_email_select_elements
                            .length
                        "
                        overlap
                        offset-x="6"
                        offset-y="-3"
                      />
                    </v-btn>
                  </template>
                  <span> Send email </span>
                </v-tooltip>
              </template>
              <v-list dense>
                <v-list-item
                  link
                  v-for="lang in langs"
                  :key="lang"
                  @click="send_email(lang)"
                >
                  <v-list-item-title> {{ lang }} </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-fab-transition>
              <v-btn
                v-show="
                  this.$store.state.messages.Send_by_email_select !== undefined
                "
                fab
                dark
                class="email_select_cancel"
                color="#EE6C4D"
                @click="email_select_cancel"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-fab-transition>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <emoji-history @submit="addHistoryEmoji" />
  </div>
</template>

<script>
import Chat from "./Chat";
import MsgOptions from "./Message_options";
import Mlook from "./MessageFormats/Mlook.vue";
import Grid from "./MessageFormats/Grid";
import Carsul from "./MessageFormats/ProdCarosule";
import Buttons from "./MessageFormats/Buttons";
import Brands from "./MessageFormats/Brands";
import Attachment from "./MessageFormats/Attachments";
import AgnetAssign from "./MessageDashFiles/AgnetAssign.vue";
import Dots from "./MessageFormats/TapingDots";
import "../../assets/messenger.scss";
import { VueEditor, Quill } from "vue2-editor";
import Emoji from "quill-emoji";
import "quill-emoji/dist/quill-emoji.css";
import utils from "../../utils";
import store from "../../store";
import EmojiHistory from "./emojiHistory.vue";
import { apiRequest } from "../../api";

Quill.register(
  {
    "formats/emoji": Emoji.EmojiBlot,
    "modules/short_name_emoji": Emoji.ShortNameEmoji,
    "modules/toolbar_emoji": Emoji.ToolbarEmoji,
    "modules/textarea_emoji": Emoji.TextAreaEmoji,
  },
  true
);

export default {
  data: () => {
    return {
      generateAiQestion: false,
      write: false,
      chat_length: 0,
      chat_input: "",
      isSelecting: false,
      url: null,
      selectedFile: null,
      mail: true,
      fab: false,
      email_send_loader: false,
      md_resize: false,
      xl_resize: false,
      selected_email_msgs: [],
      langs: ["fr", "en"],
      editorOptions: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [
                { align: ["", "center", "right", "justify"] },
                { list: "ordered" },
                { list: "bullet" },
              ],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ color: [] }, { background: [] }, "link", "clean"],
              ["historyEmoji"],
            ],
            handlers: {
              historyEmoji: function () {
                if (
                  store.state.admin?.admin_details?.details?.emojisList?.length
                ) {
                  store.dispatch("setEmojiHistory", { showing: true });
                }
              },
            },
          },
          toolbar_emoji: false,
          short_name_emoji: true,
          textarea_emoji: true,
        },
      },
    };
  },
  props: {
    context: Object,
  },
  components: {
    Chat,
    MsgOptions,
    Mlook,
    Carsul,
    Attachment,
    Buttons,
    Brands,
    Grid,
    VueEditor,
    Dots,
    AgnetAssign,
    EmojiHistory,
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
  },
  watch: {
    chat_input(val) {
      if (!val) this.chat_blur();
      if (!this.write && val) {
        console.log("writing..");
        this.$socket.emit("AdmChatTyping", {
          state: "focus",
          user_id: this.userID,
        });
        this.write = true;
      }
    },
  },
  computed: {
    messengerConfig() {
      const data = this.$store.state.admin.admin_details.details
        .messengerConfig;
      return data;
    },
    userID() {
      return this.$store.state.user_selected;
    },
    disableRating() {
      const lastMessage = this.$store.state.messages.messages[
        this.$store.state.messages.messages.length - 1
      ];
      if (
        lastMessage?.content?.content?.type === "rating" ||
        lastMessage?.content?.type === "rating"
      )
        return true;
      return false;
    },
    user_messages() {
      return this.$store.state.messages.messages;
    },
  },
  updated() {
    //eleminate the scroll toEnd in this case
    if (
      this.chat_length !== this.$store.state.messages.messages.length &&
      this.$store.state.messages.Send_by_email_select === undefined
    ) {
      this.chat_length = this.$store.state.messages.messages.length;
      this.scrollToEnd();
    }
  },
  mounted() {
    this.chat_length = this.$store.state.messages.messages.length;
    this.onResizeMsg();
    window.addEventListener("resize", this.onResizeMsg, { passive: true });

    this.scrollToEnd();
    this.$vuetify.goTo(window.innerWidth);
    if (this.$store.state.chat_user.email) this.mail = false;
  },
  async destroyed() {
    if (this.write) await this.chat_blur();

    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResizeMsg, { passive: true });
    }
    this.$store.dispatch("selector/select", {
      active: false,
    });

    //email elemets state
    this.selected_email_msgs = [];
    this.$store.state.messages.Send_by_email_select_elements = [];
    this.$store.state.messages.Send_by_email_select = undefined;
    //=------------------/
  },
  methods: {
    addHistoryEmoji(emoji) {
      this.$refs.editor.quill.insertText(
        this.$refs.editor.quill.getLength() - 1,
        emoji
      );
    },
    chat_focus() {
      // console.log("focus");
      if (this.chat_input) {
        console.log("writing ...");
        this.$socket.emit("AdmChatTyping", {
          state: "focus",
          user_id: this.userID,
        });
        this.write = true;
      }
    },
    chat_blur() {
      if (this.write) {
        console.log("stop writing");
        this.$socket.emit("AdmChatTyping", {
          state: "blur",
          user_id: this.userID,
        });
        this.write = false;
      }
    },
    disable_options(msg) {
      if (typeof msg.content === "object") {
        if (
          msg.content.attachment ||
          (msg.content.buttons &&
            msg.content.buttons[0] &&
            msg.content.buttons[0].name != "nomore.restart") ||
          msg.content.carousel ||
          msg.content.form ||
          msg.content.grid ||
          msg.content.look
        )
          return true;
      }
      return false;
    },
    onResizeMsg() {
      this.md_resize = window.innerWidth < 829;
      this.xl_resize = window.innerWidth < 1260;
      // console.log("mobilemsg", this.md_resize);
    },
    DetectEmail(item) {
      try {
        if (!item) {
          return { match: false, found: null };
        }
        const text =
          typeof item.content === "object"
            ? item.content.message
            : item.content;
        if (text?.length && item.sender_type === "self") {
          var matches = text.match(
            /[a-zA-Z0-9+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+/g
          );
          if (matches) {
            return { match: true, found: matches };
          }
        }
        return { match: false, found: null };
      } catch (e) {
        console.log("error in email detection", e);
        return { match: false, found: null };
      }
    },
    LogThis() {
      console.log("change");
    },
    SetEmail(matches) {
      this.$store.dispatch("setEmailDetectBox", {
        showing: true,
        emails: matches,
        curr_email:
          this.$store.state.chat_user.email ||
          this.$store.state.chat_user.contact,
        user_guid: this.$store.state.chat_user.guid,
      });
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 92;
    },
    onButtonClick() {
      this.$store.dispatch("setAttachBox", {
        showing: true,
      });
    },
    chat_sender(sendBy, msg) {
      let ob = {};
      if (sendBy === "self") ob = { class: "left", icon: "mdi-account-circle" };
      else if (sendBy === "bot")
        ob = { class: "right_bot", icon: "mdi-alpha-b-circle" };
      else ob = { class: "right" };
      return ob;
    },
    get_time() {
      const today = new Date();
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const month = monthNames[today.getMonth()].substr(0, 3);
      const date = `${today.getDate()} ${month} ${today.getFullYear()}`;
      const time = `${today.getHours()}:${
        (today.getMinutes() < 10 ? "0" : "") + today.getMinutes()
      }`;
      const dateTime = date + "  " + time;
      return dateTime;
    },
    get_user_last_msg() {
      for (let i = this.$store.state.messages.messages.length - 1; i > 0; i--) {
        const element = this.$store.state.messages.messages[i];
        if (element.sender_type === "self") return element.content;
      }
    },
    submit(whatsapp = false) {
      // console.log("origin text:", this.chat_input);
      // console.log("sanitize text:", utils.CleanTextEnterd(this.chat_input));
      const save = this.chat_input;
      this.chat_input = utils.CleanTextEnterd(this.chat_input);
      if (!this.check_if_empty(this.chat_input)) {
        const obj = {
          message: this.chat_input,
          user: this.$store.state.chat_user.guid,
          conversation_id: this.$store.state.user_conversation_id,
          look: false,
          sender_type: "admin",
          content: this.chat_input,
          context: whatsapp
            ? "whatsapp_mode"
            : this.$store.state.chat_user.context,
        };
        this.$socket.emit("ChatUser", obj, (data) => {
          if (typeof data === "string") {
            console.error(data);
          } else {
            this.$refs.editor.quill.deleteText(0, this.chat_input.length);
            this.chat_input = "";
            obj.user = this.$store.state.chat_user.id;
            this.$store.state.messages.new_msg = true;
          }
          if (whatsapp) {
            this.$store
              .dispatch("SEND_WHATSAPP_MESSAGE", {
                guid: this.$store.state.chat_user.guid,
                message: save,
              })
              .then((r) => {
                console.log(r);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "can't note send empty messages",
          color: "error",
          timeout: 3000,
        });
      }
    },
    check_if_empty(msg) {
      if (!msg.length) return true;
      return false;
    },
    scrollToEnd() {
      var content = this.$refs.container;
      content.scrollTop = content.scrollHeight;
    },
    looks() {
      this.$store
        .dispatch("selector/select", {
          active: true,
          multiple: true,
          chat: true,
        })
        .then((prod) => {
          if (prod.length) {
            let res = [];
            Object.values(prod).forEach((element) => {
              res.push(element.prod_data);
            });
            const client_obj = {
              content: {
                message: this.$t("messanger.chat.send_looks"),
                carousel: {
                  type: "products",
                  values: res,
                },
              },
              user: this.$store.state.chat_user.guid,
              conversation_id: this.$store.state.user_conversation_id,
              sender_type: "admin",
              context: "chat",
            };
            this.$socket.emit("ChatUser", client_obj, (data) => {
              if (typeof data === "string") {
                console.error(data);
              }
              // else {
              //   client_obj.user = this.$store.state.user.users[
              //     this.$store.state.chat_user.guid
              //   ].id;
              // }
            });
          }
        });
    },
    compute_rating() {
      const obj = {
        message: this.$t("messanger.rating.message"),
        user: this.$store.state.chat_user.guid,
        conversation_id: this.$store.state.user_conversation_id,
        look: false,
        sender_type: "admin",
        content: {
          type: "rating",
          message: this.$t("messanger.rating.message"),
        },
        context: "chat",
      };
      this.$socket.emit("ChatUser", obj, (data) => {
        if (typeof data === "string") {
          console.error(data);
        } else {
          this.chat_input = "";
          obj.user = this.$store.state.chat_user.id;
          this.$store.state.messages.new_msg = true;
        }
      });
    },
    select_elements_email(msg) {
      if (!this.selected_email_msgs.includes(msg.id_msg)) {
        this.selected_email_msgs.push(msg.id_msg);
        this.$store.state.messages.Send_by_email_select_elements.push(msg);
      } else {
        const index = this.selected_email_msgs.indexOf(msg.id_msg);
        this.selected_email_msgs.splice(index, 1);
        this.$store.state.messages.Send_by_email_select_elements.splice(
          index,
          1
        );
      }
    },
    email_select_cancel() {
      this.selected_email_msgs = [];
      this.$store.state.messages.Send_by_email_select_elements = [];
      this.$store.state.messages.Send_by_email_select = undefined;
    },
    force_selection_elements() {
      const index1 = this.$store.state.messages.Send_by_email_select_elements.findIndex(
        (r) => r.sender_type === "self"
      );
      const index2 = this.$store.state.messages.Send_by_email_select_elements.findIndex(
        (r) => r.sender_type === "admin"
      );
      const index3 = this.$store.state.messages.Send_by_email_select_elements.findIndex(
        (r) => r.sender_type === "bot"
      );
      if (this.$store.state.messages.Send_by_email_select === "answer") {
        if (index1 >= 0 && (index2 >= 0 || index3 >= 0)) {
          return { value: true };
        }
        return {
          value: false,
          text:
            "Email Answer type require to select messages from user and admin side",
        };
      } else if (
        this.$store.state.messages.Send_by_email_select === "transfer" ||
        this.$store.state.messages.Send_by_email_select ===
          "transfer_without_email" ||
        this.$store.state.messages.Send_by_email_select === "transfer_store"
      ) {
        if (index1 >= 0) {
          return { value: true };
        }
        return {
          value: false,
          text: "Email transfer type require to select messages from user side",
        };
      } else {
        return { value: false };
      }
    },
    send_email(lang) {
      const froce_check = this.force_selection_elements();
      if (froce_check.value) {
        this.email_send_loader = true;
        const obj = {
          to: this.$store.state.chat_user.email,
          elements: this.$store.state.messages.Send_by_email_select_elements,
          type: this.$store.state.messages.Send_by_email_select,
          lang: lang,
          conversation_id: this.$store.state.user_conversation_id,
        };
        this.$store
          .dispatch("SEND_TO_MAIL", obj)
          .then((r) => {
            this.$store.dispatch("setSnackbar", {
              text: `Email sent to ${r.message.accepted.join(", ")}`,
              color: "success",
              top: true,
              timeout: 3000,
            });
            this.email_send_loader = false;
            this.email_select_cancel();
          })
          .catch((err) => {
            console.log(err);
            this.$store.dispatch("setSnackbar", {
              text: err.message || err,
              color: "error",
              top: true,
              timeout: 3000,
            });
            this.email_send_loader = false;
            this.email_select_cancel();
          });
      } else {
        this.$store.dispatch("setSnackbar", {
          text: froce_check.text,
          color: "warning",
          top: true,
          timeout: 5000,
        });
      }
    },
    time_format(msg) {
      // console.log("call time >> ", msg);
      const time = msg.sent_at;
      const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hourCycle: "h23",
      };

      const d = (new Date(time) + "").split(" ");
      const tmp = [d[2], d[1], d[3], d[4]].join(" ");
      const b = new Date();
      const a = new Date(tmp);
      let diff = Math.abs(a - b);
      const ms = diff % 1000;
      diff = (diff - ms) / 1000;
      const ss = diff % 60;
      diff = (diff - ss) / 60;
      const mm = diff % 60;
      diff = (diff - mm) / 60;
      const hh = diff % 24;
      const days = (diff - hh) / 24;

      if (!days && !hh && !mm) {
        return "a few seconds";
      } else {
        return new Date(time).toLocaleDateString(
          this.$i18n.locale == "fr" ? "fr-FR" : "en-US",
          options
        );
      }
    },
    last_message(item) {
      let ls = "";
      if (typeof item === "object") {
        if (Object.keys(item).includes("carousel") && item.carousel)
          ls = { key: "Carousel" };
        else if (Object.keys(item).includes("attachment") && item.attachment)
          ls = { key: "Attachment" };
        else if (Object.keys(item).includes("look") && item.look)
          ls = { key: "Look" };
        else if (Object.keys(item).includes("form") && item.form)
          ls = `From of ${item.message.split(".")[0]}`;
        else if (Object.keys(item).includes("buttons") && item.buttons)
          ls = `${item.message.split(".")[0]} Selection`;
        else if (Object.keys(item).includes("grid") && item.grid)
          ls = { key: "Grid" };
        else if (Object.keys(item).includes("brands") && item.brands)
          ls = { key: "Brands" };
        else ls = item.message;
      } else ls = item;
      return ls;
    },
    remove(array, element) {
      const index = array.indexOf(element);

      if (index !== -1) {
        array.splice(index, 1);
      }
    },
    out() {
      // and new changes to dash on click on the go back btn
      if (
        this.$store.state.messages.messages.length !==
        this.$store.state.messages.messages_length
      ) {
        const index = this.$store.state.messages.filter_rest.findIndex(
          (x) => x.guid === this.$store.state.chat_user.guid
        );
        if (index > -1) {
          let newMsg = this.$store.state.messages.messages[
            this.$store.state.messages.messages.length - 1
          ];
          this.$store.state.messages.filter_rest[
            index
          ].last_message = this.last_message(newMsg.content);
          this.$store.state.messages.filter_rest[index].sender_type =
            newMsg.sender_type;
          this.$store.state.messages.filter_rest[index].waiting =
            newMsg.waiting;
          this.$store.state.messages.filter_rest[index].sent_at =
            newMsg.send_time;
          let temp = this.$store.state.messages.filter_rest[index];

          this.remove(this.$store.state.messages.filter_rest, temp);
          this.$store.state.messages.filter_rest.splice(0, 0, temp);
          this.$store.state.messages.new_msg = false;
        }
      }

      this.$store.state.show.dash = true;
      this.$store.state.chat_user = "";
      this.$store.state.save_status = "";
      this.$store.state.messages.messages = [];
      this.$store.state.show.chat = false;
    },
    generate_next_response() {
      this.generateAiQestion = true;
      apiRequest()
        .post("admin/IaAnswer", {
          user_id: this.userID,
          lang: this.$i18n.locale,
        })
        .then((res) => {
          this.generateAiQestion = false;
          this.fill_next_response(res.data);
        })
        .catch((err) => {
          console.log(err);
          this.generateAiQestion = false;
        });
    },
    fill_next_response(response) {
      this.chat_input = response;
    },
  },
};
</script>

<style>
.chat-box .ql-editor {
  min-height: 218px;
  max-height: 218px;
  font-size: 16px;
}

.chat-box .ql-tooltip {
  left: 3.2891px !important;
  margin-top: 0px;
  top: -38px !important;
}
.chat-box .ql-toolbar {
  text-align: -webkit-center;
}

.chat-box .ql-snow .ql-toolbar button,
.ql-snow.ql-toolbar button {
  width: auto !important;
  min-width: 28px;
}

.chat-box .ql-snow .ql-picker-options {
  bottom: 25px !important;
}

.chat-box .ql-snow .ql-picker.ql-expanded .ql-picker-options {
  top: -101px !important;
}

.chat_more_btn {
  height: 26px !important;
  width: 26px !important;
  right: -10px !important;
}
.EmailFound {
  position: absolute;
  left: 8px;
  top: 2px;
  border-radius: 18px;
  z-index: 1;
}
.email-message-select {
  position: absolute;
  left: 0px;
  top: 0;
}
.email_btn {
  height: 28px !important;
  width: 28px !important;
  right: -10px !important;
  top: -12px !important;
}
.email_btn_left {
  left: 32px !important;
}
.email_select_cancel {
  position: fixed;
  top: 16%;
  right: 46%;
  z-index: 999999;
  transform-origin: center center;
}
.message-time .v-list-item {
  min-height: 0px !important;
}

.message-time .v-list-item .v-list-item__subtitle {
  line-height: 1 !important;
}
.ap {
  margin: 4px;
}
#textarea-emoji {
  max-width: 300px;
}
#tab-toolbar {
  text-align: -webkit-center;
}
.text_area textarea {
  min-height: 83px !important;
  resize: none;
}
.ql-historyEmoji {
  position: relative; /* making the .tooltip span a container for the tooltip text */
  border-bottom: 1px dashed #000; /* little indicater to indicate it's hoverable */
  content: "📎";
}

.ql-historyEmoji::after {
  content: "📎";
}

.ql-historyEmoji:before {
  content: "Most used emojis"; /* here's the magic */
  position: absolute;

  /* vertically center */
  top: 50%;
  transform: translateY(-50%);

  /* move to right */
  left: 100%;
  margin-left: 15px; /* and add a small left margin */

  /* basic styles */
  width: 100px;
  padding: 10px;
  border-radius: 10px;
  background: #8f8f8f;
  color: #fff;
  text-align: center;

  display: none; /* hide by default */
}

.ql-historyEmoji:hover:before {
  display: block;
}
</style>
